<template>
  <div 
    class="mt-1">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Detail Perusahaan

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0" v-if="Object">
              <v-form>
                <v-row>
                  <v-col cols="6">
                    
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.detail = false; dialog.fullscreen = false; ">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->

        <v-dialog
          v-model="dialog.compare"
          max-width="420"
          persistent>
          <v-card class="border-radius">
            <v-card-title class="fs-14 font-weight-bold pb-2">
              Tambah Perbandingan
            </v-card-title>
            <v-card-text class="pt-0">
              <v-menu
                v-model="compareDateMenu"
                :close-on-content-click="false"
                offset-y
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    filled
                    rounded
                    dense
                    hide-details
                    readonly
                    :color="set_color"
                    placeholder="Pilih Rentang Tanggal"
                    :value="compareDateRangeText"
                    prepend-inner-icon="mdi-calendar-range"
                    class="fs-12"
                    v-bind="attrs"
                    v-on="on">
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="compareForm.dateRange"
                  range
                  no-title
                  locale="id-ID"
                  :color="set_color">
                </v-date-picker>
              </v-menu>
              <div v-if="compareForm.error" class="error--text fs-12 mt-2">
                {{ compareForm.error }}
              </div>
            </v-card-text>
            <v-card-actions class="px-4 pb-4">
              <v-spacer></v-spacer>
              <v-btn
                text
                class="text-capitalize"
                @click="dialog.compare = false">
                Batal
              </v-btn>
              <v-btn
                :loading="process.compare"
                :color="set_color"
                dark
                class="text-capitalize"
                @click="addComparison">
                Tambah
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Pegawai
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      to="/user/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row> -->
          <div>
              <div
                class="lr-page-toolbar px-4 mt-2"
                :class="{ 'lr-page-toolbar--wide': comparisons.length > 0 }">
                <div class="lr-page-toolbar__title">
                  <h1 class="lr-page-toolbar__heading">Laba Rugi</h1>
                  <span v-if="saldoPeriodText" class="lr-page-toolbar__period">{{ saldoPeriodText }}</span>
                </div>

                <div class="lr-page-toolbar__actions lr-filters flex-wrap">
                <div>
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        filled
                        rounded
                        dense
                        hide-details
                        readonly
                        :color="set_color"
                        placeholder="Pilih Rentang Tanggal"
                        :value="dateRangeText"
                        prepend-inner-icon="mdi-calendar-range"
                        class="fs-12 cf-filter-field"
                        style="border-radius: 6px; width: 230px; min-width: 230px; max-width: 230px;"
                        v-bind="attrs"
                        v-on="on">
                      </v-text-field>
                    </template>

                    <v-date-picker
                      v-model="filter.dateRange"
                      range
                      no-title
                      locale="id-ID"
                      :color="set_color"
                      @change="onDateRangeChange">
                    </v-date-picker>
                  </v-menu>
                </div>
                <v-select
                  filled
                  rounded
                  dense
                  hide-details
                  class="fs-12 lr-filter-field lr-filter-position"
                  :color="set_color"
                  placeholder="Posisi"
                  :items="position"
                  v-model="filter.position"
                  @change="onPositionChange">
                </v-select>

                <v-btn
                  @click="openCompareDialog"
                  elevation="0"
                  rounded
                  small
                  min-height="30"
                  class="lr-filter-action lr-filter-btn lr-filter-btn--compare"
                  title="Tambah Perbandingan">
                  <v-icon size="18" class="lr-filter-btn--compare__icon">mdi-compare</v-icon>
                  <span class="lr-filter-btn__label">Bandingkan</span>
                </v-btn>

                <v-btn
                  v-if="hak_akses.action.export"
                  @click="exports()"
                  :loading="process.export"
                  elevation="0"
                  rounded
                  small
                  min-height="30"
                  class="lr-filter-action lr-filter-btn lr-filter-btn--pdf"
                  title="Export PDF">
                  <v-icon size="18" class="lr-filter-btn--pdf__icon">mdi-file-pdf-box</v-icon>
                  <span class="lr-filter-btn__label">PDF</span>
                </v-btn>

                <v-btn
                  v-if="hak_akses.action.export"
                  @click="exports_excel()"
                  :loading="process.export_excel"
                  elevation="0"
                  rounded
                  small
                  min-height="30"
                  class="lr-filter-action lr-filter-btn lr-filter-btn--excel"
                  title="Export Excel">
                  <v-icon size="18" class="lr-filter-btn--excel__icon">mdi-microsoft-excel</v-icon>
                  <span class="lr-filter-btn__label">Excel</span>
                </v-btn>
                </div>
              </div>

              <div
                class="px-4 mt-3 lr-content-wrap"
                :class="{ 'lr-content-wrap--wide': comparisons.length > 0 }">
                <div class="lr-hero">
                  <div class="lr-hero__main">
                    <div class="lr-hero__label">{{ profitLabel }}</div>
                    <div class="lr-hero__value">{{ displayTotals.labaRugi | price }}</div>
                  </div>

                  <div class="lr-hero__secondary">
                    <div class="lr-hero__metric">
                      <span class="lr-hero__marker lr-hero__marker--income" title="Pendapatan"></span>
                      <div class="lr-hero__metric-body">
                        <div class="lr-hero__metric-label">Pendapatan</div>
                        <div class="lr-hero__metric-value">{{ displayTotals.pendapatan | price }}</div>
                      </div>
                    </div>

                    <div class="lr-hero__divider" aria-hidden="true"></div>

                    <div class="lr-hero__metric">
                      <span class="lr-hero__marker lr-hero__marker--expense" title="Biaya"></span>
                      <div class="lr-hero__metric-body">
                        <div class="lr-hero__metric-label">Biaya</div>
                        <div class="lr-hero__metric-value">{{ displayTotals.biaya | price }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <v-row class="pa-4 px-0">
                <v-col cols="12" class="py-0">
                  <v-card
                    flat
                    class="lr-card"
                    :class="{ 'lr-card--compact': !comparisons.length }">
                    <v-card-text
                      v-if="process.load"
                      class="lr-loading">
                      <div class="text-center" style="width: 320px;">
                        <div class="mb-4 title">Mohon Tunggu . . .</div>
                        <v-progress-linear
                          :color="set_color"
                          indeterminate
                          rounded
                          height="10">
                        </v-progress-linear>
                      </div>
                    </v-card-text>

                    <template v-else>
                      <div
                        v-if="hasReportData"
                        class="lr-report px-2 pb-2"
                        :class="{ 'lr-report--wide': comparisons.length > 0 }">
                        <laba-rugi-report-table
                          :pendapatan="list_pendapatan"
                          :biaya="list_biaya"
                          :comparisons="comparisons"
                          :display-totals="displayTotals"
                          :profit-label="profitLabel"
                          :saldo-period-text="saldoPeriodText"
                          :color="set_color"
                          :get-saldo="itemSaldo"
                          :get-compare-saldo="getCompareSaldo"
                          @remove-comparison="removeComparison">
                        </laba-rugi-report-table>
                      </div>

                      <div v-else class="lr-empty">
                        <v-img
                          class="mx-auto"
                          contain
                          alt="empty"
                          :width="90"
                          :height="90"
                          :src="require('@/assets/image/empty.png')">
                        </v-img>
                        <div class="mt-3 fs-16">Belum Ada Laba Rugi</div>
                      </div>
                    </template>
                  </v-card>
                </v-col>
              </v-row>
            </div>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import LabaRugiReportTable from "@/components/laba-rugi/LabaRugiReportTable.vue"
  export default {
    data () {
      return {
        checkbox: false,
        selected_data: '',
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false,
          compare: false,
        },
        laba_rugi: 0,
        
        search: '',

        dateMenu: false,
        compareDateMenu: false,
        comparisons: [],
        compareForm: {
          dateRange: [],
          error: ''
        },
        filter: {
          dateRange: [
            moment().startOf('month').format('YYYY-MM-DD'),
            moment().endOf('month').format('YYYY-MM-DD')
          ],
          position: 'Internal'
        },

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          activa: '',
          biaya: ''
        },
        position: ['Internal', 'Public'],

        role: [],

        options: {},
        headers: [],
        list: [],
        list_pendapatan: [],
        list_biaya: [],
        pagination: {},
        total_pendapatan: 0,
        total_biaya: 0,
        total_pendapatan_public: 0,
        total_biaya_public: 0,
        laba_rugi_public: 0,

        lastIndex: 0,
        limit: 20,

        form: {
          month: moment().format('YYYY-MM'),
          position: '',
          biaya_array: [],
          pendapatan_array: []
        },

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          form: false,
          export: false,
          export_excel: false,
          compare: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      LabaRugiReportTable,
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      hak_akses () {
        let menu = {}
        // console.log(this.$store.state.menu)
        this.$store.state.menu.map(item => {
          if (item.id === 3) {
            menu = item
          }
        })
        return menu
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      sortedDateRange () {
        const range = this.filter.dateRange || []
        if (range.length < 2) return range

        return [...range].sort((a, b) => moment(a).diff(moment(b)))
      },
      dateRangeText () {
        const [start, end] = this.sortedDateRange

        if (!start) return ''
        if (!end || start === end) return moment(start).format('DD MMM YYYY')

        return `${moment(start).format('DD MMM YYYY')} - ${moment(end).format('DD MMM YYYY')}`
      },
      saldoPeriodText () {
        const [start, end] = this.sortedDateRange
        moment.locale('id')

        const formatDate = (date) => moment(date).format('D MMMM YYYY')

        if (!start) return ''
        if (!end || start === end) return formatDate(start)

        return `${formatDate(start)} - ${formatDate(end)}`
      },
      hasReportData () {
        return this.list_pendapatan.length > 0 || this.list_biaya.length > 0
      },
      displayTotals () {
        const isPublic = this.filter.position === 'Public'

        return {
          pendapatan: isPublic ? this.total_pendapatan_public : this.total_pendapatan,
          biaya: isPublic ? this.total_biaya_public : this.total_biaya,
          labaRugi: isPublic ? this.laba_rugi_public : this.laba_rugi
        }
      },
      profitLabel () {
        return Number(this.displayTotals.labaRugi) < 0 ? 'Rugi' : 'Laba Rugi'
      },
      queryParams () {
        const [start, end] = this.sortedDateRange

        return {
          start_date: start,
          end_date: end || start,
          position: (this.filter.position).toLowerCase()
        }
      },
      compareDateRangeText () {
        const range = this.normalizeDateRange(this.compareForm.dateRange)
        const [start, end] = range

        if (!start) return ''
        if (!end || start === end) return moment(start).format('DD MMM YYYY')

        return `${moment(start).format('DD MMM YYYY')} - ${moment(end).format('DD MMM YYYY')}`
      },
      years () {
        let max = new Date().getFullYear()+4, min = max - 8, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      },
      months () {
        let numb = new Date().getMonth() + 1
        

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    created () {
      if (String(this.$store.state.user.cat_id) === '21' || String(this.$store.state.user.cat_id) === '23') {
        this.position = ['Public']
        this.filter.position = 'Public'
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      onDateRangeChange (range) {
        if (range && range.length === 2) {
          this.dateMenu = false
          this.fetch()
        }
      },

      onPositionChange () {
        this.fetch()
        this.refetchAllComparisons()
      },

      normalizeDateRange (range) {
        const r = range || []
        if (r.length < 2) return r

        return [...r].sort((a, b) => moment(a).diff(moment(b)))
      },

      formatPeriodText (range) {
        const [start, end] = this.normalizeDateRange(range)
        moment.locale('id')

        const formatDate = (date) => moment(date).format('D MMMM YYYY')

        if (!start) return ''
        if (!end || start === end) return formatDate(start)

        return `${formatDate(start)} - ${formatDate(end)}`
      },

      rangeKey (range) {
        const [start, end] = this.normalizeDateRange(range)
        return `${start}|${end || start}`
      },

      isDuplicateCompareRange (range) {
        const key = this.rangeKey(range)
        if (key === this.rangeKey(this.filter.dateRange)) return true

        return this.comparisons.some(c => this.rangeKey(c.dateRange) === key)
      },

      buildSaldoMap (items, position) {
        const map = {}
        const isPublic = position === 'Public'

        const walk = (list) => {
          if (!Array.isArray(list)) return

          list.forEach(item => {
            map[item.id] = isPublic ? (item.saldo_public * 1) : (item.saldo * 1)
            if (item.child && item.child.length) walk(item.child)
          })
        }

        walk(items)
        return map
      },

      extractTotals (data, position) {
        const isPublic = position === 'Public'

        return {
          pendapatan: isPublic ? data.total_pendapatan_public * 1 : data.total_pendapatan * 1,
          biaya: isPublic ? data.total_biaya_public * 1 : data.total_biaya * 1,
          labaRugi: isPublic ? data.laba_rugi_public * 1 : data.laba_rugi * 1
        }
      },

      async fetchComparisonData (dateRange) {
        const [start, end] = this.normalizeDateRange(dateRange)

        const response = await get(`lostprofit/data`, {
          params: {
            start_date: start,
            end_date: end || start,
            position: (this.filter.position).toLowerCase()
          }
        })

        const res = response.data

        if (res.status !== 200) {
          throw new Error(res.message || 'Gagal memuat data perbandingan')
        }

        const data = res.results.data
        const pendapatan = data.pendapatan_array || []
        const biaya = data.biaya_array || []
        const saldoMap = {
          ...this.buildSaldoMap(pendapatan, this.filter.position),
          ...this.buildSaldoMap(biaya, this.filter.position)
        }

        return {
          saldoMap,
          totals: this.extractTotals(data, this.filter.position)
        }
      },

      getCompareSaldo (cmpId, item) {
        const cmp = this.comparisons.find(c => c.id === cmpId)
        if (!cmp || !cmp.saldoMap) return 0

        return cmp.saldoMap[item.id] || 0
      },

      openCompareDialog () {
        this.compareForm.error = ''
        this.compareForm.dateRange = [
          moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
        ]
        this.dialog.compare = true
      },

      async addComparison () {
        const range = this.compareForm.dateRange

        if (!range || range.length < 2) {
          this.compareForm.error = 'Pilih rentang tanggal lengkap'
          return
        }

        if (this.isDuplicateCompareRange(range)) {
          this.compareForm.error = 'Periode ini sudah digunakan'
          return
        }

        this.process.compare = true
        this.compareForm.error = ''

        try {
          const { saldoMap, totals } = await this.fetchComparisonData(range)

          this.comparisons.push({
            id: `cmp_${Date.now()}`,
            dateRange: [...this.normalizeDateRange(range)],
            periodText: this.formatPeriodText(range),
            loading: false,
            error: '',
            saldoMap,
            totals
          })
          this.dialog.compare = false
        } catch (err) {
          this.compareForm.error = (err && err.message) || 'Gagal memuat data perbandingan'
        } finally {
          this.process.compare = false
        }
      },

      removeComparison (id) {
        this.comparisons = this.comparisons.filter(c => c.id !== id)
      },

      async refetchAllComparisons () {
        if (!this.comparisons.length) return

        const updated = await Promise.all(this.comparisons.map(async (cmp) => {
          try {
            const { saldoMap, totals } = await this.fetchComparisonData(cmp.dateRange)

            return {
              ...cmp,
              saldoMap,
              totals,
              loading: false,
              error: ''
            }
          } catch (err) {
            return {
              ...cmp,
              loading: false,
              error: (err && err.message) || 'Gagal memuat'
            }
          }
        }))

        this.comparisons = updated
      },

      itemSaldo (item) {
        return this.filter.position === 'Public' ? item.saldo_public : item.saldo
      },

      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = this.queryParams

        this.selected.row = []

        await get(`lostprofit/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list_pendapatan = []
          this.list_biaya = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              // {
              //   text: 'Aksi',
              //   width: '120px',
              //   value: 'id',
              //   freeze: true,
              //   hide: false,
              //   align: 'center',
              //   format: 'action'
              // },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama',
                width: '100%',
                value: 'name',
                freeze: false,
                hide: false
              }
            ]
            this.list_pendapatan = res.results.data.pendapatan_array
            this.list_biaya = res.results.data.biaya_array
            this.total_pendapatan = res.results.data.total_pendapatan*1
            this.total_biaya = res.results.data.total_biaya*1
            this.laba_rugi = res.results.data.laba_rugi*1
            this.total_pendapatan_public = res.results.data.total_pendapatan_public*1
            this.total_biaya_public = res.results.data.total_biaya_public*1
            this.laba_rugi_public = res.results.data.laba_rugi_public*1
            // this.list.map((item, index) => {
            //   this.total_pendapatan += (item.balance*1)
            // })

            // this.list_biaya.map((item, index) => {
            //   this.total_biaya += (item.balance*1)
            // })

            // this.list = res.results.data
            // this.pagination = res.results.pagination


            // this.lastIndex = (pagination.page - 1) * pagination.row 
            // this.lastIndex += 1

            // this.addFreezes()

            // this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper-laba-rugi') })

            // if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      // closeForm() {
      //   this.form.biaya_array = []
      //   this.form.pendapatan_array = []
      //   this.list_pendapatan.map((item, index) => {
      //     this.form.pendapatan_array.push(item)
      //   })

      //   this.list_biaya.map((item, index) => {
      //     this.form.biaya_array.push(item)
      //   })
      // },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        this.form.month = moment().format('YYYY-MM')
        this.form.position = ''
        this.message.error = ''
        this.form.biaya_array = []
        this.form.pendapatan_array = []
        this.list_pendapatan.map((item, index) => {
          this.form.pendapatan_array.push(item)
        })

        this.list_biaya.map((item, index) => {
          this.form.biaya_array.push(item)
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = 'neraca/initial/add'

          // SAVE TO REST API
          await post(url, {
            data: {
              month: this.form.month,
              position: this.form.position,
              biaya_array: this.form.biaya_array,
              pendapatan_array: this.form.pendapatan_array
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              // if (this.form.id === '') {
              //   this.fetch()
              // } else {
              //   this.fetch(this.paginationList)
              // }
              this.fetchData()
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/satuan/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      },
      async exports () {
        this.message.error = ''

        this.process.export = true

        let params = this.queryParams

        await axios({
          url: `${process.env.VUE_APP_API_URL}/lostprofit/export_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },
      async exports_excel () {
        this.message.error = ''

        this.process.export_excel = true

        let params = this.queryParams

        await axios({
          url: `${process.env.VUE_APP_API_URL}/lostprofit/export_excel`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export_excel = false
          // console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          // let filename = ''

          // if (disposition && disposition.indexOf('inline') !== -1) {
          //   var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          //   var matches = filenameRegex.exec(disposition);
          //   if (matches != null && matches[1]) { 
          //     filename = matches[1].replace(/['"]/g, '');
          //   }
          // }
          console.log(fileName)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }

    }
  }
</script>


<style scoped>
  .lr-page-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px 16px;
    max-width: 960px;
    width: 100%;
  }

  .lr-page-toolbar--wide {
    max-width: none;
  }

  .lr-page-toolbar__title {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1 1 180px;
  }

  .lr-page-toolbar__heading {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #111827;
    line-height: 1.2;
  }

  .lr-page-toolbar__period {
    font-size: 12px;
    font-weight: 400;
    color: #6b7280;
    line-height: 1.3;
  }

  .lr-page-toolbar__actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }

  .lr-filters {
    gap: 8px;
    align-items: center;
  }

  .lr-filter-date {
    flex: 1 1 220px;
    max-width: 280px;
    min-width: 180px;
  }

  .lr-filter-position {
    flex: 0 1 130px;
    min-width: 110px;
    max-width: 150px;
  }

  .lr-filter-action {
    flex: 0 0 auto;
    border-radius: 6px !important;
  }

  .lr-filter-btn {
    min-height: 30px !important;
    height: 30px !important;
    padding: 0 10px !important;
    box-shadow: none !important;
    letter-spacing: normal;
    text-transform: none !important;
    font-weight: 600 !important;
    font-size: 11px !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 4px !important;
  }

  .lr-filter-btn__label {
    line-height: 1;
  }

  .lr-filter-btn:hover {
    background-color: rgba(0, 0, 0, 0.09) !important;
  }

  .lr-filter-btn::before {
    opacity: 0 !important;
  }

  /* Perbandingan — Okabe-Ito blue (beda dari hijau/merah export, ramah buta warna) */
  .lr-filter-btn--compare {
    background-color: #e8f2f8 !important;
    border: 1px solid #9ec5de !important;
    color: #0072b2 !important;
  }

  .lr-filter-btn--compare:hover {
    background-color: #d4e8f4 !important;
    border-color: #0072b2 !important;
  }

  .lr-filter-btn--compare__icon {
    color: #0072b2 !important;
  }

  /* Export PDF — Okabe-Ito vermillion */
  .lr-filter-btn--pdf {
    background-color: #fdf0e8 !important;
    border: 1px solid #e8b196 !important;
    color: #d55e00 !important;
  }

  .lr-filter-btn--pdf:hover {
    background-color: #fae3d4 !important;
    border-color: #d55e00 !important;
  }

  .lr-filter-btn--pdf__icon {
    color: #d55e00 !important;
  }

  /* Export Excel — Okabe-Ito bluish green */
  .lr-filter-btn--excel {
    background-color: #e6f5f0 !important;
    border: 1px solid #9dd4c0 !important;
    color: #009e73 !important;
  }

  .lr-filter-btn--excel:hover {
    background-color: #d4ede4 !important;
    border-color: #009e73 !important;
  }

  .lr-filter-btn--excel__icon {
    color: #009e73 !important;
  }

  .lr-filters >>> .v-text-field,
  .lr-filters >>> .v-select {
    border-radius: 6px;
  }

  .lr-filters >>> .v-text-field--rounded > .v-input__control > .v-input__slot {
    padding: 0 15px !important;
  }

  .lr-filters >>> .v-text-field--filled.v-input--dense > .v-input__control > .v-input__slot,
  .lr-filters >>> .v-text-field--outlined.v-input--dense > .v-input__control > .v-input__slot,
  .lr-filters >>> .v-select.v-input--dense > .v-input__control > .v-input__slot {
    min-height: 30px !important;
  }

  .lr-filters >>> .v-text-field--enclosed.v-input--dense .v-input__append-inner,
  .lr-filters >>> .v-text-field--enclosed.v-input--dense .v-input__append-outer {
    margin-top: 4px !important;
  }

  .lr-filters >>> .v-text-field--enclosed.v-input--dense .v-input__prepend-inner {
    margin-top: 4px !important;
  }

  .lr-filters >>> .v-text-field--enclosed.v-input--dense .v-input__slot .v-icon {
    font-size: 16px !important;
  }

  .lr-content-wrap {
    max-width: 960px;
    width: 100%;
  }

  .lr-content-wrap--wide {
    max-width: none;
  }

  .lr-hero {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    gap: 16px 24px;
    padding: 14px 16px;
    background: #f9fafb;
    border: 1px solid #e8eaed;
    border-radius: 10px;
  }

  .lr-hero__main {
    flex: 1 1 220px;
    min-width: 0;
  }

  .lr-hero__label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6b7280;
    margin-bottom: 4px;
    line-height: 1.3;
  }

  .lr-hero__value {
    font-size: 26px;
    font-weight: 700;
    color: #111827;
    font-variant-numeric: tabular-nums;
    line-height: 1.2;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .lr-hero__secondary {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0;
    flex: 0 1 auto;
    padding-top: 2px;
  }

  .lr-hero__metric {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    min-width: 140px;
    padding: 0 20px 0 0;
  }

  .lr-hero__metric-body {
    min-width: 0;
  }

  .lr-hero__divider {
    width: 1px;
    align-self: stretch;
    background: #e0e3e8;
    margin: 2px 20px 2px 0;
  }

  .lr-hero__metric-label {
    font-size: 11px;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: 3px;
    line-height: 1.3;
  }

  .lr-hero__metric-value {
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    font-variant-numeric: tabular-nums;
    line-height: 1.3;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .lr-hero__marker {
    flex-shrink: 0;
    margin-top: 4px;
  }

  .lr-hero__marker--income {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #0072b2;
  }

  .lr-hero__marker--expense {
    width: 8px;
    height: 8px;
    border-radius: 1px;
    background: #e69f00;
  }

  .lr-card {
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
  }

  .lr-card--compact {
    max-width: 960px;
  }

  .lr-card >>> .v-card__text {
    padding: 0;
  }

  .lr-loading,
  .lr-empty {
    min-height: calc(100vh - 320px);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
  }

  .lr-empty {
    flex-direction: column;
    color: #6b7280;
  }

  .lr-report {
    max-width: 960px;
    width: 100%;
    min-width: 0;
  }

  .lr-report--wide {
    max-width: none;
  }

  @media (max-width: 1264px) {
    .lr-page-toolbar:not(.lr-page-toolbar--wide),
    .lr-content-wrap:not(.lr-content-wrap--wide),
    .lr-report:not(.lr-report--wide),
    .lr-card--compact {
      max-width: 100%;
    }

    .lr-hero__value {
      font-size: 22px;
    }

    .lr-hero__metric-value {
      font-size: 13px;
    }
  }

  @media (max-width: 960px) {
    .lr-page-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .lr-page-toolbar__actions {
      margin-left: 0;
    }

    .lr-hero {
      flex-direction: column;
      gap: 12px;
    }

    .lr-hero__secondary {
      width: 100%;
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
      padding-top: 0;
      border-top: 1px solid #e8eaed;
      padding-top: 12px;
    }

    .lr-hero__divider {
      width: 100%;
      height: 1px;
      margin: 0;
    }

    .lr-hero__metric {
      padding-right: 0;
      min-width: 0;
    }

    .lr-filter-date,
    .lr-filter-position {
      flex: 1 1 100%;
      max-width: 100%;
    }
  }

  @media (max-width: 600px) {
    .lr-page-toolbar,
    .lr-filters {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }

    .lr-content-wrap {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }

    .lr-filter-btn__label {
      display: none;
    }

    .lr-filter-btn {
      padding: 0 8px !important;
      min-width: 30px !important;
    }

    .lr-loading,
    .lr-empty {
      min-height: calc(100vh - 280px);
    }
  }
</style>

<style>
/* Legacy grid styles — jangan timpa tabel Laba Rugi */
.wrapper-laba-rugi table:not(.lr-table),
.wrapper-laba-rugi table:not(.lr-table) th,
.wrapper-laba-rugi table:not(.lr-table) td {
  border-spacing: 4px;
  border-collapse: collapse;
}

.lr-table,
.lr-table th,
.lr-table td {
  border-spacing: 0 !important;
  border-collapse: separate !important;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper-laba-rugi { 
  overflow-y: auto; 
  height: calc(100vh - 260px); 
} 
.wrapper-laba-rugi th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
} 
.list_hover:hover {background-color: #1976d236;}
.selected {background-color: #1976d236;}

</style>